import { PurplePill } from '@/shared/components/ui/purple-pill'
import { IAmount } from '@/types/amount'
import { ReactNode } from 'react'

type PlanFeature = {
  text: ReactNode
  highlight?: boolean
}

export type Plan = {
  id: string
  name: string
  price: IAmount
  description: string
  features: PlanFeature[]
  isMonthlyPlan?: boolean
}

export const plans: Plan[] = [
  {
    id: 'free',
    name: 'Explorer',
    price: { amount: 0, currency: 'EUR' },
    description: 'Try Mydra',
    features: [
      {
        text: (
          <>
            <span className="font-semibold">5 AI playbooks/workflows</span> -
            Public
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">50 AI messages/month</span> (hosted
            execution)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">
              Unlimited off-platform execution
            </span>{' '}
            (export to corporate LLMs)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">7-day result retention</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Personal workspace only</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Public Playbooks only</span> (all
            user-created templates are public)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Unlimited result sharing</span>{' '}
            (with Mydra branding)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Template marketplace browsing</span>{' '}
            (view all, use 5)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Community support</span>
          </>
        ),
      },
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: { amount: 5900, currency: 'EUR' },
    description: 'For everyday productivity',
    features: [
      {
        text: (
          <>
            <span className="font-semibold">
              Unlimited AI playbooks/workflows
            </span>{' '}
            (access to full library/unlimited playbook creation)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Unlimited AI messages/month</span>{' '}
            (hosted execution)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">
              Unlimited off-platform execution
            </span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">90-day result retention</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">
              Personal workspace + guest collaboration
            </span>{' '}
            (3 guests max)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Private Playbooks</span> (keep your
            templates confidential)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Priority support</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">
              <span className="text-mydra-gray">
                Custom branding when sharing results
              </span>{' '}
              <PurplePill text="Soon" />
            </span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">
              <span className="text-mydra-gray">
                Personal analytics dashboard
              </span>{' '}
              <PurplePill text="Soon" />
            </span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="text-mydra-gray">
              <span className="font-semibold">Advanced integrations</span> (10+
              platforms)
            </span>{' '}
            <PurplePill text="Soon" />
          </>
        ),
      },
    ],
    isMonthlyPlan: true,
  },
  {
    id: 'teams',
    name: 'Teams',
    price: { amount: 7900, currency: 'EUR' },
    description: '5-20x more usage than Pro',
    features: [
      {
        text: (
          <>
            <span className="font-semibold">Everything in Pro</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Unlimited team members</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Unlimited guest collaboration</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Private Team Playbooks</span>{' '}
            (internal templates only)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Team analytics & insights</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Admin controls & permissions</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Team template library</span> (create
            & share unlimited)
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Advanced workflow automation</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Advanced integrations</span>
          </>
        ),
      },
      {
        text: (
          <>
            <span className="font-semibold">Unlimited result retention</span>
          </>
        ),
      },
    ],
    isMonthlyPlan: true,
  },
]
